import { authRequest } from './client';
import {
  type FireblocksEventDetailResponse,
  type ListFireblocksEventsParams,
  type ListFireblocksEventsResponse,
} from './types';

// ─── backoffice-api fireblocks-events client ───────────────────────────────
//
// Thin fetch wrappers around backoffice-api's `/v1/fireblocks-events`
// endpoints (Task 30 — raw custody provider events). Reads require
// TECH_VIEWER (or SUPERADMIN), the manual retry (feature-041) TECH_MANAGER.
// `eventType`/`resourceId` are free-text filters (no fixed enum vocabulary
// on the backend DTO).

export function listFireblocksEvents(
  params: ListFireblocksEventsParams = {},
): Promise<ListFireblocksEventsResponse> {
  const query = new URLSearchParams();

  if (params.page !== undefined) query.set('page', String(params.page));
  if (params.pageSize !== undefined) query.set('pageSize', String(params.pageSize));
  if (params.eventType !== undefined) query.set('eventType', params.eventType);
  if (params.resourceId !== undefined) query.set('resourceId', params.resourceId);
  if (params.publishStatus !== undefined) query.set('publishStatus', params.publishStatus);
  if (params.from !== undefined) query.set('from', params.from);
  if (params.to !== undefined) query.set('to', params.to);

  const qs = query.toString();
  return authRequest<ListFireblocksEventsResponse>(`/fireblocks-events${qs ? `?${qs}` : ''}`);
}

export function getFireblocksEvent(id: string): Promise<FireblocksEventDetailResponse> {
  return authRequest<FireblocksEventDetailResponse>(`/fireblocks-events/${id}`);
}

/** Hands a FAILED event back to the outbox relay; 409 if it is not FAILED (e.g. already retried). */
export function retryFireblocksEvent(id: string): Promise<FireblocksEventDetailResponse> {
  return authRequest<FireblocksEventDetailResponse>(`/fireblocks-events/${id}/retry`, { method: 'POST' });
}
